import { PermissionsState } from '@app/store/permissions/models/permissions.models';
import { permissionsFeatureKey } from '@app/store/permissions/reducers/permissions.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectPermissionsState = createFeatureSelector<PermissionsState>(permissionsFeatureKey);

export const selectAllPermissions = createSelector(selectPermissionsState, state => state);
export const selectReadCompaniesPerm = createSelector(selectPermissionsState, state => state.readCompanies);
